import React, { useEffect, useMemo, useState } from 'react'
import { avatarUrl, letterAvatar } from '../utils/avatar'

const UserAvatar = ({ src, name, alt = '', userId, onError, ...rest }) => {
  const [broken, setBroken] = useState(false)
  const label = name || alt || 'U'
  const fallback = useMemo(() => letterAvatar(label), [label])
  const live = useMemo(() => avatarUrl(src, label), [src, label])

  useEffect(() => {
    setBroken(false)
  }, [src, userId, label])

  return (
    <img
      alt={alt}
      {...rest}
      src={broken ? fallback : live}
      onError={(event) => {
        if (broken) return
        setBroken(true)
        if (onError) onError(event)
      }}
    />
  )
}

export default UserAvatar
